<template>
    <div class="travel-expense-tab">
        <!-- Primeiro nivel: um lote por linha, como no Diversos. Clicar o lote abre a grid por funcionario
             daquele lote. v-show (nao v-if): o board por funcionario so carrega a grid no watch. -->
        <boardTravelExpenseLote
            v-show="loteSelecionado === null"
            :dataexpensesResponse="dataexpensesResponse"
            @selecionarLote="loteSelecionado = $event"
            @needGetDespesasViagemDiretoria="getDespesasViagemDiretoria"
        />
        <div v-show="loteSelecionado !== null">
            <button class="btn-voltar-lote mb-2" @click="loteSelecionado = null"><i class="fas fa-arrow-left mr-1"></i> VOLTAR AOS LOTES</button>
            <boardTravelExpenseEmployee
                :dataexpensesResponse ="dataexpensesResponseDoLote"
                :loteSelecionado="loteSelecionado"
                @alterarFuncionario="getDespesasViagemDiretoria"
                @needGetDespesasViagemDiretoria="getDespesasViagemDiretoria"
            />
        </div>
    </div>
</template>

<script>
import boardtrevelexpenseemployee from './components/boardtrevelexpenseemployee/boardtrevelexpenseemployee.vue'
import boardtravelexpenselote, { chaveDoLote } from './components/boardtravelexpenselote/boardtravelexpenselote.vue'
import TravelExpenseRepository from '@/shared/http/repositories/business/travelexpense.js'
import { loading } from '@/shared/utils/UIHelper'
import ActionsForm from '@/shared/mixins/actionsForm'
import localStoreHelper from '@/shared/utils/localStoreHelper.js'
export default {
  components: {
    boardTravelExpenseEmployee: boardtrevelexpenseemployee,
    boardTravelExpenseLote: boardtravelexpenselote
  },
  mixins: [ActionsForm],
  props: {
    funcionarioId: {
      type: String,
      default: ''
    },
    Lote: {
      type: String,
      default: ''
    },
    shouldSearch: {
      type: Boolean,
      default: false
    }
  },
  mounted () {
    this.getDespesasViagemDiretoria()
  },
  methods: {
    async getDespesasViagemDiretoria (lote, funcionarioId) {
      loading.push()
      let data = {}
      if (lote == null && funcionarioId == null) {
        data = localStoreHelper.prestacaoContas.viagem()
      } else {
        data = {
          Lote: lote,
          FuncionarioId: funcionarioId
        }
      }
      TravelExpenseRepository.GetAllUsuarioByStatusDiretoria(this.CompanySelected, data)
        .then((Response) => {
          loading.pop()
          this.dataexpenses = Response.data.data
          this.dataexpensesResponse = Response
          // this.dataexpensesResponse.data.data.forEach((Element) => {
          //   Element['coordenador'] = Element.despesasViagens.map((ElementdespesasViagens) => ElementdespesasViagens.dataAtualizacaoCoordenador)[0]
          //   Element['controladoria'] = Element.despesasViagens.map((ElementdespesasViagens) => ElementdespesasViagens.dataAtualizacaoControladoria)[0]
          // })
          let valorTotal = 0
          let localidade = null
          localidade = this.dataexpenses[0].localidade
          this.dataexpenses.forEach(x => {
            valorTotal = x.despesasViagemTotalDto.totalGasto + valorTotal
          })
          this.$emit('despesaViagemValorTotal', valorTotal)
          this.$emit('localidade', localidade)
        })
        .catch((Error) => {
          loading.pop()
        })
    }
  },
  computed: {
    // Resposta do GetAllUsuarioByStatusDiretoria recortada no lote clicado, no formato que o
    // boardTravelExpenseEmployee ja espera (ele le `data.data` e repassa ao LoadAllByData).
    dataexpensesResponseDoLote () {
      if (this.loteSelecionado === null || !this.dataexpensesResponse.data) return {}
      const linhas = (this.dataexpensesResponse.data.data || []).filter(x => chaveDoLote(x) === this.loteSelecionado)
      return { ...this.dataexpensesResponse, data: { ...this.dataexpensesResponse.data, data: linhas, count: linhas.length } }
    }
  },
  watch: {
    dataexpensesResponseDoLote (value) {
      // Lote aprovado/reprovado por inteiro sai da fila: volta para a lista de lotes.
      if (this.loteSelecionado !== null && value.data && value.data.data.length === 0) this.loteSelecionado = null
    },
    funcionarioId (value) {
      console.log(value)
      this.deveProcurar++
    },
    Lote () {
      this.deveProcurar++
    },
    deveProcurar () {
      if (this.Lote) {
        this.Lote = parseInt(this.Lote)
      }
      this.getDespesasViagemDiretoria(this.Lote ? this.Lote : undefined, this.funcionarioId)
    }
  },
  data () {
    return {
      deveProcurar: 0,
      loteSelecionado: null,
      dataexpensesResponse: {},
      dataexpenses: [],
      loteLocal: null,
      funionarioLocal: null
    }
  }
}
</script>
<style scoped>
.travel-expense-tab{
    width:100%
}
.btn-voltar-lote{
    background: #6c757d;
    color: white;
    border: none;
    border-radius: 5px;
    font-weight: bold;
    padding: 4px 12px;
}
</style>



// WEBPACK FOOTER //
// src/views/private/finance/accountability/components/travelExpenseTab/travelExpenseTab.vue